import { generateUniqueId } from './generateUniqueId';

export function addIdToObjects<T>(objects: T[]): (T & { id: string })[] {
  return objects.map(obj => ({
    ...obj,
    id: generateUniqueId(),
  }));
}